import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { utils } from "../../Helpers/utils";
import AddBrief from "./AddBrief";
import BriefData from "./BriefData";
import {
  SearchInput,
  SelectInput,
  Pagination,
  download,
  plusIcon,
  searchIcon,
  Profile,
  Toast,
  arrowLeft,
  notifIcon,
  pencilIcon,
  AiLogo,
  shareIcon,
} from "../../Components";

import { useSearchParams, useNavigate } from "react-router-dom";
import { briefService } from "../../Services";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { storageHandler } from "../../Helpers/storage";
import { parseInput } from "../../Components/Constants/AppConstant";

const selectDescList = [
  { id: "1", value: "All" },
  { id: "title", value: "Title" },
];

export default function Briefing({
  setAuth,
  setModal,
  NotifModul,
  user,
  profiles,
  setModalNotification,
  closeCartPanel,
  cartItem,
  goToPricing,
  setOfferSelectedForReview,
  onStartChat,
}) {
  // eslint-disable-next-line
  const [selectDesc, setselectDesc] = useState(selectDescList[0].value);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isloaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [briefList, setBriefList] = useState(null);
  const [toastList, setToastList] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [searchList, setSearchList] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [disableSearchBox, setDisableSearchBox] = useState(false);
  const [showListing, setShowListing] = useState(true);
  const location = useLocation();
  const [tab, setTab] = useState("main");
  const [goBack, setGoBack] = useState(false);
  const [generatedBriefResponse, setGeneratedBriefResponse] = useState(null);
  const [forbiddenMessage, setForbiddenMessage] = useState(false);
  /*useEffect(() => {
    let offersucess = searchParams.get('offersuccess') !== null ? searchParams.get('offersuccess') : '';
    //let successMessage = searchParams.get('success') !== null ? searchParams.get('success') == 1 ? "Plan  is successfully subscribe." : '' : '';
    if (offersucess !== '') {
      setUserHasSubscription(true);
      setShowListing(false);
      //checkout()
    } else {
      setShowListing(true);
    }
  }, []);*/

 

  useEffect(() => {
    async function fetchData() {
      try {
        let filter = "";
        if (searchString !== "") {
          if (filter != "") {
            filter += "title=" + searchString;
          } else {
            filter = "title=" + searchString;
          }
        }
        const res = await briefService.getAll({
          page: page,
          pageSize,
          filter: filter,
        });
        console.log(res);
        if (res.success === true) {
          console.log(res.data.data);
          setBriefList(res.data.data);
          let paginationObj = utils.createPaginationData(res.data);
          setPaginationData(paginationObj);
          //setRowCount((res.data.data.length));
          setForbiddenMessage(false);
          setIsLoaded(true);
        }
        // console.log(res.data.data)
      } catch (err) {
        if (err.apiResponseStatus === 403) {
          setForbiddenMessage(true);
        } else {
          setForbiddenMessage(false);
          let error = parseInput(err.message);
          addToast({
            error: true,
            msg:
              typeof err === "string"
                ? err.replace(/<[^>]*>/g, "")
                : error.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
      }
    }
    fetchData();
  }, [page, searchList]);

  const onPaginate = (page) => {
    setPage(page);
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        search();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [searchString]);

  const changeMediumDesc = (item) => {
    setselectDesc(item.id);
    setPage(1);
    if (item.id === "lastyr" || item.id === "30days") {
      setDisableSearchBox(true);
    } else {
      setDisableSearchBox(false);
    }
    setSearchString("");
    setSearchList(!searchList);
  };

  const setSearchStringText = (event) => {
    if (event.target.value === "") {
      setSearchList(!searchList);
    }
    setSearchString(event.target.value);
  };

  const search = () => {
    setSearchList(!searchList);
    setPage(1);
  };
  const addBrief = () => {};

  const editBrief = async (id) => {
    console.log("dsf");
    try {
      const res = await briefService.getBrief(id);
      console.log(res);
      if (res.success == true) {
        setGeneratedBriefResponse(res.data);
        setTab("savebrief");
      }
    } catch (err) {
      addToast({
        error: true,
        msg:
          typeof err === "string" ? err.replace(/<[^>]*>/g, "") : err.message,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };
 
  let data = null;
    try {
      const userInfo = storageHandler.getUserInfo();
      if (userInfo) {
        const parsed = JSON.parse(userInfo);
        data = parsed?.data || null;
      }
    } catch (error) {
      console.error("Error parsing user info:", error);
    }
    useEffect(() => {
      data.p_f_ids.includes(6);
    }, []);
  return (
    <>
      {data.p_f_ids.includes(6) ?(
        <>
          <div className="main">
            <div className="main__inner">
              {tab !== "main" && tab !== "savebrief" && (
                <button
                  className="button tertiary big"
                  onClick={() => {
                    setGoBack(!goBack);
                    setTab("main");
                    onPaginate(1);
                  }}
                >
                  {arrowLeft} Back to list
                </button>
              )}
              {/* <div className='main__inner-title'>
                <div className="main__inner-title-col aiLogoInTitle"><h2>Brief Generator {AiLogo}</h2>
                  {(tab !== "main" && tab !== "savebrief") && (
                    <button
                      className="button tertiary big"
                      onClick={() => { setGoBack(!goBack); setTab("main"); onPaginate(1); }}
                    >
                      {arrowLeft} Back to list
                    </button>)}</div>
                <Profile
                  type='brand'
                  setAuth={setAuth}
                  setModal={setModal}
                  NotifModul={NotifModul}
                  user={user}
                  profiles={profiles}
                  setNotifModul={setModalNotification}
                  closeCartPanel={closeCartPanel}
                  cartItem={cartItem}
                />
              </div> */}
              {forbiddenMessage === false ? (
                isloaded &&
                tab == "main" && (
                  <div className="billing dashboard briefingSearch">
                    <div className="billing__table-title pag ">
                      <button
                        className="button tertiary big"
                        onClick={() => setTab("add")}
                      >
                        Add Brief {plusIcon}
                      </button>
                      <div className="billing__table-title-inner">
                        <SearchInput
                          type="text"
                          icon={searchIcon}
                          placeholder="Search"
                          onClick={search}
                          onChange={setSearchStringText}
                          value={searchString}
                          disable={disableSearchBox}
                        />
                      </div>
                    </div>

                    <div className="billing__table">
                      <table>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Title</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {briefList.length > 0 ? (
                            <>
                              {briefList.map((item, index) => {
                                return (
                                  <tr>
                                    <td>{utils.formatdate(item.created_at)}</td>
                                    <td>{item.title}</td>

                                    <td>
                                      <div className="briefAction">
                                        <div>{pencilIcon}</div>
                                        <div>{shareIcon}</div>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </>
                          ) : (
                            <tr>
                              <td colSpan="5" style={{ textAlign: "center" }}>
                                No records
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="billing__table-footer paginationEnd">
                      {briefList && briefList.length > 0 && (
                        <Pagination
                          perPage={paginationData["per_page"]}
                          total={paginationData["total"]}
                          currentPage={paginationData["current_page"]}
                          totalPages={paginationData["total_pages"]}
                          onPaginate={onPaginate}
                        />
                      )}
                    </div>
                  </div>
                )
              ) : (
                <div className="billing dashboard briefingSearch">
                  <div className="billing__table-title pag ">
                    <div onClick={goToPricing}>
                      <img
                        className="showProfileImgCursor"
                        src={`${process.env.PUBLIC_URL}/images/placeholder/briefing-generator.png`}
                      />
                    </div>
                  </div>
                </div>
              )}

              {tab == "add" && (
                <div className="billing dashboard">
                  <div className="">
                    <AddBrief
                      setTab={setTab}
                      setGeneratedBriefResponse={setGeneratedBriefResponse}
                      setToastList={setToastList}
                      toastList={toastList}
                    />
                  </div>
                </div>
              )}
              {tab == "savebrief" && (
                <div className="billing dashboard">
                  <div className="">
                    <BriefData
                      setTab={setTab}
                      generatedBriefResponse={generatedBriefResponse}
                      setToastList={setToastList}
                      toastList={toastList}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      ): (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Brief Generator"}
            background={"background_offers.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
}
